// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "webfount/js/" + chunkId + "." + {"127":"01bc2de2","270":"52688cb5","277":"ba967498","311":"e1a1cf79","372":"700baa52","378":"3bf0f6ab","440":"e7880057","466":"d76c6fc9","545":"d6e05a0e","567":"1ef535f4","658":"0a9de18a","879":"00a21923","901":"2f25d7b7"}[chunkId] + ".js";
};